import {
  TimeQuestionConfig,
  TimeResponseState,
  TimeType,
} from '@gripp/shared-logic';
import { FC } from 'react';
import { RoutineQuestionMessageProps } from '../../types';
import { DateOnlyMessage } from './dateOnlyMessage';
import { StartEndTimeMessage } from './startEndTimeMessage';
import { TimeAndDateMessage } from './timeAndDateMessage';
import { TimeOnlyMessage } from './timeOnlyMessage';

type TimeMessageTypeComponent = FC<
  RoutineQuestionMessageProps<TimeQuestionConfig, TimeResponseState>
>;
export const TimeMessageTypeComponents: Record<
  TimeType,
  TimeMessageTypeComponent
> = {
  [TimeType.StartEndTimes]: StartEndTimeMessage,
  [TimeType.TimeOnly]: TimeOnlyMessage,
  [TimeType.DateOnly]: DateOnlyMessage,
  [TimeType.TimeAndDate]: TimeAndDateMessage,
};
